// Import environment variable for determining the current deployment environment
import { DEP_ENVIRONMENT } from "../BaseUrl";

// Define configuration constants based on different environments
export const AuthConstant = {
  // Configuration for the user acceptance testing (UAT) environment
  uat: {
    client_id: "8997fda7-d94c-4406-804f-aa75ccad07db",
    authorization_endpoint:
      "https://login.microsoftonline.com/1e4582e8-220a-4f17-90f0-ffa94687f7b4/oauth2/v2.0/authorize",
    login_endpoint: "MSEntraID/userAndToken",
    redirect_uri: "https://ui-test.dep-vygr.com/",
    response_type: "code",
    response_mode: "query",
    scope: "openid profile email",
    state: "12345",
  },
};

// Export the configuration for the current environment based on the DEP_ENVIRONMENT variable
export const currentEnvConfig = DEP_ENVIRONMENT.toLowerCase();
